// extracted by mini-css-extract-plugin
export var root = "event-card-module--root--1sh3J";
export var description = "event-card-module--description--1ZI5X";
export var highlight = "event-card-module--highlight--10Wqx";
export var title = "event-card-module--title--2cDcj";
export var descriptionWrapper = "event-card-module--descriptionWrapper--2ya4t";
export var a11yIcon = "event-card-module--a11yIcon--sb_jL";
export var dark = "event-card-module--dark--1Q880";
export var bright = "event-card-module--bright--2J6Yq";